import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";

const { Option, OptGroup } = Select;

const SubMenuDropdown = ({
  mode,
  isFAQ,
  subService,
  options,
  city,
  defaultValue,
  data,
  isBusiness,
  disabled,
  placeholder,
  onChange,
  className,
  loadMoreData, // Function to load more data
  isService,
  loader,
  isUser,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(data || []);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    setItems(data || []);
    // if (isService) {
    //   setValue(null); // Reset value if this dropdown is for services
    // }
  }, [data]);

  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    onChange(selectedValue);
  };

  const handlePopupScroll = async (event) => {
    const { target } = event;
    if (
      target.scrollTop + target.offsetHeight === target.scrollHeight &&
      !loading
    ) {
      setLoading(true);
      const newPage = currentPage + 1;
      await loadMore(newPage);
      setCurrentPage(newPage);
      setLoading(false);
    }
  };

  const loadMore = async (page) => {
    const moreData = await loadMoreData(page);
  };

  const filterOption = (input, option) => {
    const children = option.children;
    if (typeof children === "string") {
      return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
    return false;
  };

  return (
    <Select
      placeholder={placeholder}
      disabled={disabled}
      showSearch
      filterOption={filterOption}
      onPopupScroll={handlePopupScroll}
      className={
        className
          ? className
          : "!h-5.4 flex justify-start items-center rounded-xl border-grey hover:border-primaryPurple !focus:border-primaryPurple lg:w-31 xl:w-40"
      }
      style={{ backgroundColor: "#F7F6F8" }}
      mode={mode === "multiple" ? "multiple" : ""}
      value={value}
      onChange={handleChange}
      notFoundContent={
        loader ? (
          <Spin size="small" />
        ) : items.length === 0 ? (
          "Data not found"
        ) : null
      }
    >
      {items?.map((category, i) => {
        // Check if the category has variants (sub-data)
        if (category.variants && category.variants.length > 0) {
          // Create an OptGroup for categories with variants
          return (
            <OptGroup key={i} label={`Deal: ${category.serviceName}`}>
              {/* Show main element name as the first option */}
              <Option
                key={`${i}-main`}
                value={
                  city
                    ? category?.name
                    : subService
                    ? `${category?.serviceName} - Price: $${category?.servicePrice} - Discount: ${category?.discount}%`
                    : isFAQ
                    ? category
                    : isBusiness
                    ? category?._id
                    : isService
                    ? category?._id
                    : category.abbreviation || category._id
                }
              >
                {isBusiness
                  ? category?.businessName
                  : isUser
                  ? `${category?.firstName} ${category?.lastName} (${category?.email})`
                  : category?.name ??
                    category?.variantTitle ??
                    category?.serviceName}
              </Option>

              {/* Show variants under the main element */}
              {category.variants.map((variant, j) => (
                <Option
                  key={`${i}-${j}`}
                  value={
                    city
                      ? variant.name
                      : subService
                      ? `${variant.serviceName} - Price: $${variant.servicePrice} - Discount: ${variant.discount}%`
                      : isFAQ
                      ? variant
                      : isBusiness
                      ? variant._id
                      : isService
                      ? variant._id
                      : variant.abbreviation || variant._id
                  }
                >
                  {variant.variantTitle}
                </Option>
              ))}
            </OptGroup>
          );
        } else {
          // Regular Option if no variants
          return (
            <Option
              key={i}
              title={category?.name}
              value={
                city
                  ? category?.name
                  : subService
                  ? `${category?.serviceName} - Price: $${category?.servicePrice} - Discount: ${category?.discount}%`
                  : isFAQ
                  ? category
                  : isBusiness
                  ? category?._id
                  : isService
                  ? category?._id
                  : category.abbreviation || category._id
              }
            >
              {isBusiness
                ? category?.businessName
                : isUser
                ? `${category?.firstName} ${category?.lastName} (${category?.email})`
                : category?.name ?? category?.serviceName}
            </Option>
          );
        }
      })}
    </Select>
  );
};

export default SubMenuDropdown;
